import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import _ from 'underscore'
import cookie from '../lib/cookie'
import STATUS_CODE from '../constant/status_code'
const getAddressList = (data) => {
    return new Promise( (resolve, reject)=> {
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        Api.get(`${CONSTANT.REQUEST_HOST}${query}` ,{
            headers: {
                'X-Host':'mall.user.address.list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
            }
        })
        .then((data) => {
          if (data.status == STATUS_CODE.EMPTY_LIST){
            return resolve([])
          } else if(data.status !== 0) {
            return reject(data.msg)
          }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const getDefaultAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`
        
        Api.get(url ,{
            headers: {
                'X-Host':'mall.user.address.default',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN) ,
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const addAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let url = CONSTANT.REQUEST_HOST 
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.user.address.add',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const updateAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let url = CONSTANT.REQUEST_HOST 
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.user.address.update',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const deleteAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let url = CONSTANT.REQUEST_HOST 
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.user.address.delete',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const changeDefaultAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let url = CONSTANT.REQUEST_HOST 
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.user.address.change-default',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}

const getExpressResolveAddress = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let url = CONSTANT.REQUEST_HOST 
        data = JSON.stringify(data)
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.user.address.express-resolve',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    }) 
}

/*yeoman-template-point-1*/
export default {
    getAddressList,
    getDefaultAddress,
    addAddress,
    updateAddress,
    deleteAddress,
    changeDefaultAddress,
    getExpressResolveAddress
/*yeoman-template-point-2*/
}